import './stylesheets/flat/FooterBarFlat.css'
import './stylesheets/glassmorphism/FooterBarGlassmorphism.css'
import './stylesheets/neobrutalism/FooterBarNeobrutalism.css'
import './stylesheets/neumorphism/FooterBarNeumorphism.css'


function FooterBar({style}){
    return(
        <div className={`footer-bar-${style}`}>
            <p className={`footer-bar-text-${style}`}>Made With React</p>
        </div>
    )
}

export default FooterBar